import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";

import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Feed from "./pages/Feed";
import Competitions from "./pages/Competitions";
import CompetitionDetail from "./pages/CompetitionDetail";
import Trivia from "./pages/Trivia";
import TriviaGame from "./pages/TriviaGame";
import TriviaTournamentGame from "./pages/TriviaTournamentGame";
import Trending from "./pages/Trending";
import CompetitionRecap from "./pages/CompetitionRecap";
import LiveStream from "./pages/LiveStream";
import LiveSettings from "./pages/LiveSettings";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Wallet from "./pages/Wallet";
import Upload from "./pages/Upload";
import Admin from "./pages/Admin";
import Live from "./pages/Live";
import Notifications from "./pages/Notifications";
import VerifyFace from "./pages/VerifyFace";
import Messages from "./pages/Messages";

function ProtectedRoute({ children, requireAdmin }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-white/60">Loading...</div>;
    if (!user) return <Navigate to="/login" replace />;
    if (requireAdmin && user.role !== "admin") return <Navigate to="/feed" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#141414", color: "#fff", border: "1px solid #2C2C2E" } }} />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    <Route element={<Layout />}>
                        <Route path="/feed" element={<Feed />} />
                        <Route path="/competitions" element={<Competitions />} />
                        <Route path="/competitions/:id" element={<CompetitionDetail />} />
                        <Route path="/competitions/:competitionId/trivia/play" element={<ProtectedRoute><TriviaTournamentGame /></ProtectedRoute>} />
                        <Route path="/competitions/:id/recap" element={<CompetitionRecap />} />
                        <Route path="/live/:liveId" element={<LiveStream />} />
                        <Route path="/trivia" element={<Trending />} />
                        <Route path="/trivia/lobby" element={<Trivia />} />
                        <Route path="/trending" element={<Trending />} />
                        <Route path="/trivia/:gameId" element={<ProtectedRoute><TriviaGame /></ProtectedRoute>} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/profile/:userId" element={<Profile />} />
                        <Route path="/me" element={<ProtectedRoute><MeRedirect /></ProtectedRoute>} />
                        <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
                        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                        <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                        <Route path="/messages/:otherId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
                        <Route path="/verify-face" element={<ProtectedRoute><VerifyFace /></ProtectedRoute>} />
                        <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
                        <Route path="/live" element={<Live />} />
                        <Route path="/live-settings" element={<ProtectedRoute><LiveSettings /></ProtectedRoute>} />
                        <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

function MeRedirect() {
    const { user } = useAuth();
    return <Navigate to={`/profile/${user.id}`} replace />;
}

export default App;
